import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_661e4868-d868-458c-86d6-2d10e12396a2/artifacts/tx0slj8p_ChatGPT_Image_15_de_mai._de_2026__13_56_39-removebg-preview.png";

const CookiesPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF9F6] pb-8 relative">
      <img src={LOGO_URL} alt="" className="bg-watermark" />
      
      <div className="app-container relative z-10">
        <header className="flex items-center gap-4 p-4 pt-6">
          <Link to="/" className="p-2 text-[#8E8E93] hover:text-[#2E5C55]">
            <ArrowLeft className="h-6 w-6" />
          </Link>
          <h1 className="font-bold text-xl text-[#1C1C1E]" style={{ fontFamily: 'Syne, sans-serif' }}>
            Política de Cookies
          </h1>
        </header>

        <div className="px-4 prose prose-sm max-w-none">
          <div className="card-base p-6 space-y-4 text-[#48484A]">
            <p className="text-sm text-[#8E8E93]">Última atualização: Janeiro de 2026</p>
            
            <h2 className="text-lg font-bold text-[#1C1C1E]">O que são Cookies?</h2>
            <p>
              Cookies são pequenos arquivos de texto armazenados no seu dispositivo quando você 
              visita nosso aplicativo. Eles nos ajudam a fornecer uma experiência melhor e mais 
              personalizada.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">Tipos de Cookies que Utilizamos</h2>
            
            <h3 className="font-semibold text-[#1C1C1E]">1. Cookies Essenciais</h3>
            <p>
              Necessários para o funcionamento básico do aplicativo. Incluem:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Token de autenticação:</strong> Mantém você logado</li>
              <li><strong>Preferências de sessão:</strong> Lembra suas configurações durante a visita</li>
            </ul>
            <p className="text-sm text-[#8E8E93]">
              Estes cookies não podem ser desabilitados, pois são necessários para o funcionamento do serviço.
            </p>

            <h3 className="font-semibold text-[#1C1C1E]">2. Cookies de Desempenho</h3>
            <p>
              Coletam informações anônimas sobre como você usa o aplicativo, ajudando-nos a 
              identificar e corrigir problemas. Não coletamos dados pessoais identificáveis.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">Armazenamento Local (LocalStorage)</h2>
            <p>
              Além de cookies, utilizamos o armazenamento local do navegador para:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Salvar seu token de acesso de forma segura</li>
              <li>Armazenar preferências do aplicativo</li>
              <li>Cache de dados para melhor performance</li>
            </ul>

            <h2 className="text-lg font-bold text-[#1C1C1E]">Como Gerenciar Cookies</h2>
            <p>
              Você pode controlar e excluir cookies através das configurações do seu navegador:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Chrome:</strong> Configurações → Privacidade e segurança → Cookies</li>
              <li><strong>Firefox:</strong> Opções → Privacidade e Segurança → Cookies</li>
              <li><strong>Safari:</strong> Preferências → Privacidade → Cookies</li>
              <li><strong>Edge:</strong> Configurações → Privacidade → Cookies</li>
            </ul>
            <p className="text-[#FF9F0A]">
              Atenção: Desabilitar cookies essenciais pode impedir o funcionamento correto do aplicativo.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">Cookies de Terceiros</h2>
            <p>
              Nosso aplicativo pode utilizar serviços de terceiros que definem seus próprios cookies:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Mercado Pago:</strong> Para processamento seguro de pagamentos</li>
            </ul>

            <h2 className="text-lg font-bold text-[#1C1C1E]">Atualizações desta Política</h2>
            <p>
              Podemos atualizar esta Política de Cookies periodicamente. Recomendamos que você 
              revise esta página regularmente para se manter informado sobre como utilizamos cookies.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">Contato</h2>
            <p>
              Para dúvidas sobre nossa política de cookies:
            </p>
            <p>
              <strong>Ad Inteligencia Digital LTDA</strong><br />
              CNPJ: 26.605.304/0001-76<br />
              Email: suporte@adinteligenciadigital.com.br
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;
